import { Link } from "react-router-dom";
import { SITE_META } from "@/lib/site";

/**
 * FarmersStandaloneFooter — deep-green partner-site footer.
 *
 * Matches the "Rhythm of Modern Farming" mock: solid #0F3D2A bar, cream
 * text, centered brand tag + link row + copyright.
 */
export default function FarmersStandaloneFooter({ basePath = "/" }) {
  const natureUrl = process.env.REACT_APP_NATUREPULSE_URL || "https://naturepulse.net";
  const to = (sub) => (basePath === "/" ? sub : `${basePath}${sub}`);
  const year = new Date().getFullYear();
  const support = SITE_META.emails?.support;

  return (
    <footer
      data-testid="farmers-standalone-footer"
      className="mt-16 bg-[#0F3D2A] text-[#F1EDDD]"
    >
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-8 text-center">
        <div className="text-sm">
          A <a href={natureUrl} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-white">
            NaturePulse.net™
          </a> Partner Site
        </div>
        <div className="mt-3 text-sm flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
          <Link
            to={to("/legal")}
            data-testid="footer-legal-index-link"
            className="hover:text-white"
          >
            Legal Notices
          </Link>
          <span aria-hidden>|</span>
          <Link to={to("/contact")} className="hover:text-white">Contact</Link>
          <span aria-hidden>|</span>
          <Link to={to("/api")} className="hover:text-white">API Access</Link>
          <span aria-hidden>|</span>
          <Link
            to={to("/founder-story")}
            data-testid="footer-founder-story-link"
            className="hover:text-white"
          >
            Why I created FarmersPulse
          </Link>
        </div>
        {support && (
          <div className="mt-3 text-sm" data-testid="farmers-footer-support-email">
            <a href={`mailto:${support}`} className="underline underline-offset-2 hover:text-white">
              {support}
            </a>
          </div>
        )}
        <div className="mt-3 text-xs opacity-80">
          © {year} FarmersPulse.com™. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
